import { Prestador } from './prestador.model';
import { Perfil } from './perfil.model';

/**
 * Model class representing an user
 */
export class Usuario {
  id: number;
  nome: string;
  email: string;
  prestador: Prestador;
  perfil: Perfil;
  ativo: boolean;
}
